module.exports = __webpack_public_path__ + "static/media/header_bevm.dc629f7d.svg";